// pwa/src/components/Preferences.js
import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "../utilities/context";
import { FormattedMessage, useIntl } from "react-intl";
import axios from "axios";
import Container from "@mui/material/Container";
import Layout from "./Layout";
import Grid from "@mui/material/Grid";
import {
  Button,
  Box,
} from "@mui/material";

const Preferences = () => {
  const intl = useIntl();
  const context = useContext(AppContext);
  const [preferences, setPreferences] = useState([]);

  const getPreferences = () => {
    axios
      .get("/api/marketplace/tiendanube/preferences")
      .then((response) => {
        setPreferences(response.data);
        console.log("response.data: ",response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getPreferences();
    if (context) {
      context.updateBreadcrumbsState([
        {
          label: intl.formatMessage({ id: "app.header.home.label" }),
          url: "/",
        },
        {
          label: intl.formatMessage({ id: "app.header.shop.preferences.label" }),
        },
      ]);
    }
  }, []); // Se ejecuta cuando cambia la paginación o la ordenación

  return (
    <Layout>
      <Container maxWidth={false} disableGutters>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={1}></Grid>
          <Grid item xs={12} sm={10} sx={{ textAlign: "center" }}>
            <Box sx={{ height: 400, width: "100%" }}>
                Preferences
            </Box>
          </Grid>
          <Grid item xs={12} sm={1}></Grid>
        </Grid>
      </Container>
    </Layout>
  );
};

export default Preferences;
